module.exports = __webpack_public_path__ + "img/sertifikat-3.cefe68d8.jpg";